import React from 'react'
import GlobalCSS from 'src/components/GlobalCSS'
import SEO from 'src/components/seo'
import SubPageTopLayout from 'src/components/organisms/SubPageTopLayout'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import Header from 'src/components/organisms/Header'
import Footer from 'src/components/organisms/Footer'
import Container from 'src/components/atoms/policy/Container'
import Contents from 'src/components/atoms/policy/Contents'
import Content from 'src/components/atoms/policy/Content'
import ContentRight from 'src/components/atoms/policy/ContentRight'
import ChapterName from 'src/components/atoms/policy/ChapterName'
import ListOl from 'src/components/molecules/ListOl'

const SecurityPolicy = () => {
  return (
    <div>
      <SEO title="情報セキュリティ方針" />

      <Container>
        <GlobalCSS />
        <Header />
        <SubPageTopLayout
          title="情報セキュリティ方針"
          heading="INFORMATION SECURITY POLICY"
        />
        <ContentsWrapper>
          <Contents>
            <ChapterName>基本理念</ChapterName>
            <Content>
              コミューン株式会社(以下、当社）は、
              <strong style={{ fontWeight: 'bold' }}>
                あらゆる組織とひとが融け合う未来をつくる
              </strong>
              というVisionを掲げ、事業を行っています。
              <br />
              当社の事業の中で取り扱う、お客様の情報をはじめとする情報資産は、当社の経営基盤として極めて重要なものです。
              <br />
              漏洩、き損、滅失等のリスクから、情報資産を保護することの重要性を認識した役員や従業員を含めた、情報資産を扱う者が本方針を遵守し、情報資産の機密性、完全性、可用性といった情報セキュリティを維持するための活動を実践します。
            </Content>

            <ChapterName>基本方針</ChapterName>
            <Content>
              <ListOl>
                {[
                  '情報資産を保護するために、情報セキュリティ方針ならびに、それにまつわる規程類を策定し、これに従って業務を行うとともに、情報セキュリティに関連する法令、規制その他の規範、及び、お客様との契約事項を遵守いたします。',
                  '情報資産に対して存在する漏洩、き損、滅失等のリスクを分析、評価するための基準を明確にし、体系的なリスクアセスメント方法を確立するとともに、定期的にリスクアセスメントを実施いたします。また、その結果に基づき、必要かつ適切なセキュリティ対策を実施いたします。',
                  '情報セキュリティ管理者を中心とした情報セキュリティ体制を確立するとともに、情報セキュリティに関する権限および責任を明確にいたします。また、すべての従業者が、情報セキュリティの重要性を認識し、情報資産の適切な取り扱いを確実にするために、定期的に教育、訓練および啓発を行います。',
                  '情報セキュリティポリシーの遵守状況及び情報資産の取扱いについて、定期的に点検及び監査を行い、発見された不備や改善項目については、速やかに是正処置を講じます。',
                  '情報セキュリティ上のイベントやインシデントの発生に対する適切な処置を講じるとともに、万一それらが発生した場合に際して、あらかじめ、被害を最小限に留めるための対応手順を確立し、有事の際には、速やかに対応するとともに、適切な是正処置を講じます。また、特に、業務中断に関わるようなインシデントについては、その管理の枠組みを確立し、定期的に見直しを行うことにより、当社の事業継続を確実にいたします。',
                  '基本理念を実現するための目標を定めた情報セキュリティマネジメントシステムを確立し、これを実行するとともに、継続的に見直し、改善を行います。'
                ]}
              </ListOl>
            </Content>
            <ContentRight>
              2021年1月13日 制定
              <br />
              コミューン株式会社
              <br />
              代表取締役 高田優哉
              <br />
            </ContentRight>
          </Contents>
        </ContentsWrapper>
        <Footer />
      </Container>
    </div>
  )
}

export default SecurityPolicy
